
import { Component, Vue } from 'vue-property-decorator'
import GlobalProviderService from '@/servicesTS/global-provider.service.vue'
import ModalDto from 'higia-lib-components/src/lib-components/modules/higia-modal/domain/modal.dto'
import HigiaStorageSevice from 'higia-lib-components/src/lib-components/services/higia-storage.service'
import router from '@/router'

@Component({
    name: 'App',
    components: {
        GlobalProviderService,
    },
})
export default class App extends Vue {
    modalDto: ModalDto = ModalDto.getInstance()
    higiaStorageSevice: HigiaStorageSevice

    constructor() {
        super()
        this.higiaStorageSevice = new HigiaStorageSevice()
        this.listener()
        this.syncData()
    }
    /**
     * Função para ser ouvinte das postMessages
     */
    listener() {
        console.log('listener HIGIA LOGIN')
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _self = this
        window.addEventListener('message', function (message) {
            //TODO Mapa recebido via postMessage
            if (typeof message.data === 'object' && 'get' in message.data) {
                if (message.data.get('iframesConfiguration')) {
                    _self.higiaStorageSevice.set('iframesConfiguration', message.data.get('iframesConfiguration'), true)
                }
            } else if (message.data != undefined) {
                if (message.data.sessaoExpirada) {
                    if (window.location.pathname.indexOf('/homeHigia') > -1) {
                        router.push('/homeHigia/errHigia')
                    }
                }
            }
        })
    }

    syncData() {
        var mapaTokens = new Map()
        var tokenTemp = ''
        this.higiaStorageSevice = new HigiaStorageSevice()
        setInterval(() => {
            mapaTokens = new Map()
            if (tokenTemp != this.higiaStorageSevice.get('access_token')) {
                tokenTemp = this.higiaStorageSevice.get('access_token')
            }
            mapaTokens.set('refresh_token', this.higiaStorageSevice.get('refresh_token'))
            mapaTokens.set('access_token', this.higiaStorageSevice.get('access_token'))
            mapaTokens.set('perfilLogado', this.higiaStorageSevice.get('perfilLogado'))
            mapaTokens.set('grantedAuthorities', this.higiaStorageSevice.get('grantedAuthorities'))
            this.$forceUpdate()
            this.sendmessage(mapaTokens)
        }, 50)
    }

    /**
     * TODO função de teste para postmessage
     */
    sendmessage(message: any) {
        var janela: any = document.getElementById('iframeLogin')
        if (janela && janela.contentWindow) {
            janela.contentWindow.postMessage(message, '*')
        }
    }
}
